import { render, staticRenderFns } from "./CustomerSingle.vue?vue&type=template&id=07c4f254&"
import script from "./CustomerSingle.vue?vue&type=script&lang=js&"
export * from "./CustomerSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports